export default __webpack_public_path__ + "assets/mustafaKendiguzel_cv.e80a16a1.pdf";